import { CommApiInstance} from "Utils/CommApiInstance";




const CbtMembJoinApi = async (
    loginId:string|null         ,
    passwd:string|null          ,
    membRcmdrCdRsltVal:string|null,
    ReCaptchaToken:string       ,
    joinTypeCd:string|null = "MGP",
) => {
    return await CommApiInstance.post(`memb/join`,{
        apiBody: {
            loginId:loginId             ,
            passwd:passwd               ,
            rcmdr:membRcmdrCdRsltVal    ,
            cptchTkn:ReCaptchaToken     ,
            joinTypeCd:joinTypeCd       ,
        }
    }).then((Resp) => Resp.data);
}
export default CbtMembJoinApi;